<div class="dialog-content-overlay">
  <button class="btn-close" (click)="close()"></button>
  <h1 mat-dialog-title>Invite your students and other educators</h1>
  <form [formGroup]="form" (ngSubmit)="close()">
    <div mat-dialog-content>
      <div class="form-wrapper p-0">
        <mat-form-field class="w-100">
          <mat-label>Enter email</mat-label>
          <input matInput placeholder="Enter email" formControlName="email" type="email" />
        </mat-form-field>
      </div>
    </div>
    <div mat-dialog-actions>
      <button class="main-action-btn" [disabled]="form.invalid">Invite via Email</button>
    </div>
  </form>
</div>
